import { GraphQlClient } from '@intelipost-js/secure-providers';
import { ScToast, ScDialog } from '@intelipost-js/secure-components';

export default {
  getProductGroups({ commit }, form = {}) {
    const { filters = {} } = form;
    const { sku = null } = filters;

    commit('setLoading', true);

    return GraphQlClient.query(
      `query($sku: String) {
        productGroups(sku: $sku) {
          id,
          name,
          skus,
        }
      }`, { sku })
    .then((res) => {
      commit('setLoading', false);
      const productGroups = res.data.productGroups || [];

      commit('setProductGroups', productGroups);
      return Promise.resolve(res);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },
  getProductGroup({ commit }, id) {
    commit('setLoading', true);

    return GraphQlClient.query(
      `query($id: Int) {
        productGroup(id: $id) {
          id,
          name,
          skus,
        }
      }`, { id })
      .then((res) => {
        commit('setProductGroup', res.data.productGroup || {});
        commit('setLoading', false);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('setLoading', false);
        return Promise.resolve(err);
      });
  },
  saveGroup({ commit }, params) {
    commit('setLoading', true);

    return GraphQlClient.mutation(
      `mutation(
        $id: Int,
        $name: String,
        $skus: [String]
      ){
        saveGroup(
          id: $id,
          name: $name,
          skus: $skus
        ){
          name,
        },
      }`, params)
      .then((res) => {
        commit('setLoading', false);
        ScToast.success(`O grupo foi ${params.id ? 'atualizado' : 'cadastrado'} com sucesso`);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('setLoading', false);
        return Promise.reject(err);
      });
  },
  deleteGroup({ commit, dispatch }, params) {
    const { name } = params;

    ScDialog.confirm({
      title: 'Remover grupo de produtos',
      message: `Tem certeza que deseja remover o grupo de produtos <strong>${name}</strong> ?`,
      confirmText: 'Remover',
      type: 'is-danger',
      hasIcon: true,
      icon: 'times-circle',
      onConfirm: () => {
        commit('setLoading', true);

        return GraphQlClient.mutation(
          `mutation($id: Int){
            deleteGroup(id: $id) {
              id
            },
          }`, params)
          .then((res) => {
            commit('setLoading', false);
            dispatch('getProductGroups');
            ScToast.success('O grupo foi removido com sucesso');
            return Promise.resolve(res);
          })
          .catch((err) => {
            commit('setLoading', false);
            return Promise.reject(err);
          });
      },
    });
  } };



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/product-groups/store/actions.js